import { TemplateListFormData } from '@modules/settings/SettingsPage/Components/EstimateTab/Tabs/TmEstimatorTempates/AddEditEstimatorTemplateListModal/EstimatorTemplateListForm';
import { Endpoint } from '../endpoint';
import {
  EstimatorTemplateListResponse,
  EstimatorTemplateListWithSelectionResponse,
  OrderUpdateItem,
} from '@business/entities/tm/EstimatorTemplateListResponse';
import { TMEstimateId } from '@business/entities/tm';
import { TMEstimateLineItemResponse } from '@business/entities/tm/TMEstimateResponse';

export function fetchEstimatorTemplateLists() {
  return Endpoint.get<EstimatorTemplateListResponse[]>('@gc/estimator-template-lists');
}

export function fetchEstimatorTemplateListsForEstimate(estimateId: string) {
  return Endpoint.get<EstimatorTemplateListWithSelectionResponse[]>('@gc/estimate-list-items', { params: { estimateId } });
}

export function createListItem(data: TemplateListFormData) {
  return Endpoint.post<EstimatorTemplateListResponse>('@gc/estimator-template-lists', { data });
}

export function updateListItem(id: string, data: TemplateListFormData) {
  return Endpoint.patch<EstimatorTemplateListResponse>(`@gc/estimator-template-lists/${id}`, { data });
}

export function deleteListItem(id: string) {
  return Endpoint.delete<void>(`@gc/estimator-template-lists/${id}`);
}

export function updateListOrder(items: OrderUpdateItem[]) {
  return Endpoint.post<{ success: boolean }>('@gc/estimator-template-lists/update-order', { data: { items } });
}

export function createEstimateListItem(estimateId: TMEstimateId, estimatorTemplateListId: string, providerId?: string | null) {
  return Endpoint.post<TMEstimateLineItemResponse>('@gc/estimate-list-items', { data: { estimateId, estimatorTemplateListId, providerId } });
}

export function updateEstimateListItem(
  id: string,
  data: Partial<
    Pick<TMEstimateLineItemResponse, 'quantity' | 'manualQty' | 'laborPrice' | 'materialPrice' | 'weProvide' | 'description'> & {
      providerId: string | null;
      // Why Labor / Material changed (required by the server when a price changes)
      priceNote: string;
    }
  >,
) {
  return Endpoint.patch<TMEstimateLineItemResponse>(`@gc/estimate-list-items/${id}`, { data });
}

export function deleteEstimateListItem(id: string) {
  return Endpoint.delete<{ success: boolean }>(`@gc/estimate-list-items/${id}`);
}
